// This file contains the lofic that is to be run when the app loads
// Logic related to index.vue

import accountService from './services/account';
import { environment, envConfigs } from 'services/apiConfigs';

const auth_token = localStorage.getItem('_prly_tk');

const pusher_key = environment === 'production' ? "bbcd8970612359346645" : process.env.PUSHER_STAGING_KEY;

const pusher_options = {
  cluster: 'mt1',
  forceTLS: true,
  authEndpoint: `${envConfigs.apiURL}/pusher/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${auth_token}`,
    },
  },
  activityTimeout: 20000,
  pongTimeout: 10000
};

const bootHelpCrunch = (account) => {
  if (account.role === 'teacher') {
    window.HelpCrunch('userAuth', {
      email: account.email,
      user_id: account.id,
      name: account.name,
      custom_data: {
        is_paid: account.is_paid,
      },
    });
  }
};

// See if we have a maigc link redirect in local storage
// Redirect to that activity if we do
const checkRedirects = (router, store) => {
  const { query } = router.currentRoute;
  const emailRedirect = localStorage.getItem('emailRedirect');
  const invite_code = localStorage.getItem('invite_code') || query.invite_code;
  if (invite_code) {
    localStorage.removeItem('invite_code');
    store.dispatch('useInviteCode', invite_code);
  }
  if (emailRedirect) {
    localStorage.removeItem('emailRedirect');
    router.push(emailRedirect);
  }
};

export async function appLoadAsync() {
  // Get account information first
  let account;
  try {
    const response = await accountService.completeInfo();
    account = response.data;
    this.$store.dispatch('setAccount', account);
    
    try {
      if (environment !== 'production') {
        window.Pusher.logToConsole = true;
      }
      pusher_options.auth.headers.Authorization = `Bearer ${localStorage.getItem('_prly_tk')}`;
      window.pusher = new window.Pusher(pusher_key, pusher_options);
      this.setup_individual_socket_events(account.id);
    } catch (e) {
      console.log(e);
    }
  } catch (e) {
    console.error(e);
    this.$store.dispatch('logout');
    return this.$router.go('login');
  }
  // if testing amplitude on staging, make adjust this if statement's environment logic
  // as well as the logic in analytics.actions.js

  bootHelpCrunch(account);

  checkRedirects(this.$router, this.$store);
  // restrict student
  if (account.role === 'student' && this.teacherOnlyRoute(this.$route.name)) {
    this.$router.push({ name: 'courses.index' });
  }
  this.$store.dispatch('setAccountLoading', false);

  return null;
}



// WEBPACK FOOTER //
// ./src/app/index.side-effects.js